import classNames from 'classnames';
import React, { useState } from 'react';
import { UnifiedCard } from '../../../integrations/allkort/graphql/interface/Customer';
import CardItemRow from '../../elements/cards/CardItemRow';
import FetchingAnimation from '../../elements/FetchingAnimation';
import { EqualizerIcon, InfoIconOutlined } from '../../svgs/ExpressonSVGs';

type ListCardsViewProps = {
    filteredCards?: UnifiedCard[];
    cardsContentLoading?: boolean;
    filterState: any; // Replace 'any' with the actual type of filterState if available
    applyForCardsurl: string;
    isCompany?: boolean;
    onCardUpdate?: () => void;
}

const ListCardsView: React.FC<ListCardsViewProps> = ({ filteredCards, cardsContentLoading, filterState, applyForCardsurl, isCompany = false, onCardUpdate }) => {

    // Which card row is in edit mode. Kept here (not inside CardItemRow) so the
    // open row survives the unmount/remount cycle that happens during refetch,
    // when the rows are temporarily replaced by the loading animation.
    const [openCardId, setOpenCardId] = useState<string | null>(null);

    const handleToggleRow = (cardId: string) => {
        // Bank cards can never be opened for editing — the pen is disabled in
        // CardItemRow; guard here as well so the invariant holds even if new
        // entry points are added
        const card = filteredCards?.find(c => c.id === cardId);
        if (card?.cardType === 'bankcard') return;
        setOpenCardId(prev => (prev === cardId ? null : cardId));
    };

    return (
        <div className={classNames(
            'list-cards-view')}
        >
            <div className="list-cards-view-table-wrapper">
                <div className="list-cards-view-table-wrapper__header has-dark-bg">
                    <span className="card-type">
                        Kort
                    </span>

                    <span className="card-number">
                        Kortnummer
                    </span>

                    <span className="card-name">
                        Namn
                    </span>

                    <span className="card-last-used">
                        Senast använd
                    </span>

                    <span className="card-actions">
                        Åtgärder
                    </span>
                </div>

                {
                    /* Render each card row here */
                    cardsContentLoading ? (
                        <>
                            <FetchingAnimation width={1320} maxWidth={true} height={60} marginBottom={2} marginTop={0} />
                            <FetchingAnimation width={1320} maxWidth={true} height={60} marginBottom={2} marginTop={0} />
                            <FetchingAnimation width={1320} maxWidth={true} height={60} marginBottom={2} marginTop={0} />
                        </>
                    ) : filteredCards && filteredCards.length > 0 ? (
                        <div className="cards-table-content">
                            {filteredCards.map((card) => (
                                <CardItemRow
                                    key={card.id}
                                    card={card}
                                    isCompany={isCompany}
                                    onCardUpdate={onCardUpdate}
                                    isOpen={openCardId === card.id}
                                    onToggle={handleToggleRow}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="cards-table-empty">
                            {filterState.searchTerm.trim() || filterState.typeFilters.length > 0 || filterState.includeDisabled ? (
                                <p>
                                    <EqualizerIcon width={28} height={28} />
                                    Ingen träff på nuvarande filtrering eller sökning
                                </p>
                            ) : (
                                <p>
                                    <InfoIconOutlined width={28} height={28} />
                                    Du har för närvarande inga aktiva kort, ansök via{' '}
                                    <a href={applyForCardsurl} target="_blank" rel="noopener noreferrer">
                                        Verified
                                    </a>
                                </p>
                            )}
                        </div>
                    )}
            </div>
        </div>
    );
};

export default ListCardsView;